import { styled } from 'styled-components';
import { SH1Menu, SPMenu } from '~/pages/components/styles/styles';

type IProps = {
  hidden?: boolean;
};

export function Contact({ hidden }: IProps) {
  return (
    <Container hidden={hidden}>
      <SH1Menu fontWeight="700">Contacts utiles</SH1Menu>
      <br />
      <SPMenu fontWeight="700">PC sécurité IDEEV : 01 69 15 74 46</SPMenu>
      <br />
      <SPMenu fontWeight="700">PC sécurité HM : 01 69 15 41 20</SPMenu>
    </Container>
  );
}

const Container = styled.div<{ hidden?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: ${({ hidden }) => (hidden ? '0' : '100%')};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  overflow-y: auto;
  padding: 30px;
  transition: all 0.3s 1s linear;
  width: 100%;
`;
